import { render, staticRenderFns } from "./query.vue?vue&type=template&id=48f6a68a&scoped=true"
import script from "./query.vue?vue&type=script&lang=js"
export * from "./query.vue?vue&type=script&lang=js"
import style0 from "./query.vue?vue&type=style&index=0&id=48f6a68a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f6a68a",
  null
  
)

export default component.exports